import { Button } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { RECORD_STATE } from "Constants";
import { useStoreState } from "easy-peasy";
import React, { useState } from "react";
import AbolishModal from "../../../components/abolish-modal";

export default function AbolishButton({ record, actions, loading, ...props }) {
  const { abilities } = useStoreState((store) => store.auth);

  const [abolishModalVisible, setAbolishModalvisible] = useState(false);

  const IsEnabled =
    record?.state === RECORD_STATE.ACTIVE &&
    AuthCheck(abilities, AUTH_ACTIONS.WRITE, "Sözleşmeler");

  return (
    <>
      {record?.contractStatu === "ACTIVE" && (
        <Button
          disabled={!IsEnabled}
          onClick={() => setAbolishModalvisible(true)}
        >
          Feshet
        </Button>
      )}
      {record?.contractStatu === "ABOLISH" && (
        <Button
          disabled={!IsEnabled}
          loading={loading}
          onClick={() =>
            actions.updateStatu({
              id: record?.id,
              contractStatu: "ACTIVE",
            })
          }
        >
          Feshi Geri Al
        </Button>
      )}
      <AbolishModal
        record={record}
        visible={abolishModalVisible}
        onSubmit={() => {
          actions.fetchSingle({ id: record?.id });
          setAbolishModalvisible(false);
        }}
        onCancel={() => {
          setAbolishModalvisible(false);
        }}
      />
    </>
  );
}
